let toastrInstance: any = null;

if (typeof window !== "undefined") {
  // Dynamically import toastr
  import("toastr").then((toastrModule) => {
    toastrInstance = toastrModule.default;

    // Import CSS
    import("toastr/build/toastr.min.css");

    // Configure toastr
    toastrInstance.options = {
      positionClass: "toast-top-right",
      timeOut: 4000,
      closeButton: true,
      newestOnTop: true,
      progressBar: true,
      preventDuplicates: true,
      showDuration: 4000,
      hideDuration: 1000,
      extendedTimeOut: 2000,
      showEasing: "swing",
      hideEasing: "swing",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      tapToDismiss: true,
      closeMethod: "fadeOut",
      closeDuration: 400,
      closeEasing: "swing",
      closeOnHover: false,
      onShown: function () {
        const toasts = document.querySelectorAll(".toast");
        toasts.forEach((toast) => {
          (toast as HTMLElement).style.transform = "translateZ(0) rotateX(0)";
        });
      },
    };
  });
}

export default toastrInstance;
